import { FC, ReactNode } from 'react';

import { SearchAndHighlightItem } from 'hooks/useSearchAndHighlight.types';

import { Highlighter } from './Highlighter';

type TextWithPartialHighlightRender = (props: SearchAndHighlightItem) => ReactNode;

export const defaultTextWithPartialHighlightRender: TextWithPartialHighlightRender = (part) => (
  <Highlighter searchValue={part.isHighlight ? part.value : ''} textToHighlight={part.value} />
);

export interface TextWithPartialHighlightProps {
  parts: SearchAndHighlightItem[];
  render?: TextWithPartialHighlightRender;
}

export const TextWithPartialHighlight: FC<TextWithPartialHighlightProps> = ({
  parts,
  render: Element = defaultTextWithPartialHighlightRender
}) => {
  return (
    <>
      {parts.map((item, index) => (
        <Element key={`${item.value} ${index} ${item.isHighlight}`} {...item} />
      ))}
    </>
  );
};
